<template>
  <div
    class="horizontal layout center match-answer animate__animated animate__fadeIn"
    :class="{'white': !isTextColourLight}"
    v-if="loaded"
  >
    <div class="match-answer-item horizontal layout center">
      <AhaSvg
        name="correct"
        view-box="0 0 18 18"
        maintain-color
        width="20"
        height="20"
        class="aha-option__icon icon-correct"
      />
      <div class="ml-1 mr-0.5 font-22 mt-0.5">
        {{ numberOfCorrectAnswers }}
      </div>
      <i aria-hidden="true" class="fas fa-user fa-fw mb-0.5"></i>
    </div>
    <span class="line">|</span>
    <div class="match-answer-item horizontal layout center">
      <AhaSvg
        name="incorrect"
        view-box="0 0 18 18"
        maintain-color
        width="20"
        height="20"
        class="aha-option__icon icon-incorrect"
      />
      <div class="ml-1 mr-0.5 font-22 mt-0.5">
        {{ numberOfIncorrectAnswers }}
      </div>
      <i aria-hidden="true" class="fas fa-user fa-fw mb-0.5"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import slideApi from '@/api/slide'

export default {
  props: {
  },
  data() {
    return {
      numberOfCorrectAnswers: 0,
      numberOfIncorrectAnswers: 0,
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['isTextColourLight']),
  },
  async mounted() {
    await this.getResult()
  },
  methods: {
    async getResult() {
      await new Promise((resolve) => setTimeout(resolve, 1000)) // đợi 1 giây rồi mới get data answer để đảm bảo đủ data quiz.
      const res = await slideApi.matchPairsResult(this.slideActive.id)
      this.numberOfIncorrectAnswers = res.body.data.numberOfIncorrectAnswers
      this.numberOfCorrectAnswers = res.body.data.numberOfCorrectAnswers
      setTimeout(() => {
        this.loaded = true
      }, 1000)
    },
  },
}
</script>

<style lang="scss" scoped>
.match-answer {
  background-color: rgba(10, 10, 10, 0.4);
  @apply rounded-lg;
  overflow: hidden;

  &.white {
    background-color: rgba(239, 241, 247, 0.5);
  }

  .aha-option__icon {
    background-color: #fff;
    border-radius: 18px;
    margin: 0 4px;
  }

  .match-answer-item {
    margin: 8px;
    border-radius: 4px;
  }

  .line {
    color: #D3D7E1;
  }
}
</style>
